"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var TabEditorContainer_1 = require("../../../../../../shared/components/containers/TabEditorContainer");
var CardRowButtonTextEditor_1 = require("../../../../../../shared/components/editors/CardRowButtonTextEditor");
var GameSetEditor = /** @class */ (function (_super) {
    __extends(GameSetEditor, _super);
    function GameSetEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        _this.key_additional = "additional";
        _this.css_type_desktop_menu = 1;
        return _this;
    }
    GameSetEditor.prototype.getSortOrderCategoryAvail = function () {
        var _ret = [];
        for (var i = 1; i <= 10; i++) {
            _ret.push({
                key: i,
                value: "\u041D\u043E\u043C\u0435\u0440-" + i,
            });
        }
        return _ret;
    };
    GameSetEditor.prototype.getSortOrderMenuAvail = function () {
        var _ret = [];
        for (var i = 1; i <= 10; i++) {
            _ret.push({
                key: i,
                value: "\u041D\u043E\u043C\u0435\u0440-" + i,
            });
        }
        return _ret;
    };
    GameSetEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_CSS = this.props.listCssClasses.Subscribe("*", function (id, data) {
            _this.setState({ css_classes_avail: data.data });
        });
        this.SID_GP_C = this.props.listGwsCategoryAvail.Subscribe("*", function (id, data) {
            _this.setState({
                //gameprovider_category_id: 0,
                //gameprovider_category_title: "",
                gameprovider_categories_avail: data.data
            });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    tag: _item.tag,
                    description: _item.description,
                    gameprovider_id: _item.gws_gameprovider_id,
                    gameprovider_title: _item.gws_gameprovider_title,
                    is_locked: _item.is_locked,
                    sort_order_category_key: _item.sort_order_category,
                    sort_order_category_val: "\u041D\u043E\u043C\u0435\u0440-" + _item.sort_order_category,
                    sort_order_category_avail: this.getSortOrderCategoryAvail(),
                    sort_order_menu_key: _item.sort_order_menu,
                    sort_order_menu_val: "\u041D\u043E\u043C\u0435\u0440-" + _item.sort_order_menu,
                    sort_order_menu_avail: this.getSortOrderMenuAvail(),
                    css_inactive_classname: _item.css_inactive_classname,
                    css_active_classname: _item.css_active_classname,
                    is_in_category: _item.is_in_category,
                    is_in_menu: _item.is_in_menu,
                    is_in_main_mobile_menu: _item.is_in_main_mobile_menu,
                    init_gm_cnt_in_category: _item.init_gm_cnt_in_category,
                    init_gm_cnt_in_menu: _item.init_gm_cnt_in_menu,
                    tabKey: this.key_main,
                    cms_gameset_category_type_code: _item.cms_gameset_category_type_code,
                    cms_gameset_category_type_title: _item.cms_gameset_category_type_title,
                    gameprovider_category_title: _item.gameprovider_value,
                    gameprovider_categories_avail: [],
                    css_classes_avail: []
                }, function () {
                    _this.props.listGwsCategoryAvail.LoadData(_this.state.gameprovider_id);
                    _this.props.state.setExtBreadCrumbPath(["Редактирование набора игр"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                tag: "",
                description: "",
                gameprovider_id: 0,
                gameprovider_title: "",
                is_locked: false,
                sort_order_category_key: 1,
                sort_order_category_val: "\u041D\u043E\u043C\u0435\u0440-" + 1,
                sort_order_category_avail: this.getSortOrderCategoryAvail(),
                sort_order_menu_key: 1,
                sort_order_menu_val: "\u041D\u043E\u043C\u0435\u0440-" + 1,
                sort_order_menu_avail: this.getSortOrderMenuAvail(),
                css_inactive_classname: "",
                css_active_classname: "",
                is_in_category: false,
                is_in_menu: false,
                is_in_main_mobile_menu: false,
                init_gm_cnt_in_category: 1,
                init_gm_cnt_in_menu: 1,
                cms_gameset_category_type_code: 0,
                cms_gameset_category_type_title: "",
                gameprovider_category_title: "",
                tabKey: this.key_main,
                css_classes_avail: [],
                gameprovider_categories_avail: []
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание набора игр"]);
            });
        }
        this.props.listCssClasses.LoadDataByType(this.css_type_desktop_menu);
        this.doReSetRules();
    };
    GameSetEditor.prototype.componentWillUnmount = function () {
        this.props.listCssClasses.UnSubscribe(this.SID_CSS);
        this.props.listGwsCategoryAvail.UnSubscribe(this.SID_GP_C);
    };
    GameSetEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            tag_rules: { isError: false },
            gameprovider_rules: { isError: false },
            sort_order_category_rules: { isError: false },
            sort_order_menu_rules: { isError: false },
            //css_inactive_classname_rules: { isError: false },
            //css_active_classname_rules: { isError: false },
            cms_gameset_category_type_rules: { isError: false }
        });
    };
    GameSetEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                description: this.state.description,
                title: this.state.title,
                tag: this.state.tag,
                is_locked: this.state.is_locked,
                sort_order_category: this.state.sort_order_category_key,
                sort_order_menu: this.state.sort_order_menu_key,
                css_inactive_classname: this.state.css_inactive_classname,
                css_active_classname: this.state.css_active_classname,
                is_in_category: this.state.is_in_category,
                is_in_menu: this.state.is_in_menu,
                is_in_main_mobile_menu: this.state.is_in_main_mobile_menu,
                init_gm_cnt_in_category: this.state.init_gm_cnt_in_category,
                init_gm_cnt_in_menu: this.state.init_gm_cnt_in_menu,
                cms_gameset_category_type_code: this.state.cms_gameset_category_type_code,
                gameprovider_value: this.state.gameprovider_category_title
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Набор игр изменен!");
            });
        }
    };
    GameSetEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({
                title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" },
                tabKey: this.key_main
            });
            return false;
        }
        /*if ((!this.state.css_active_classname) || (this.state.css_active_classname.length === 0)) {
            this.setState({
                css_active_classname_rules: { isError: true, errorMessage: "Поле [активный css класс] не заполнено!" },
                tabKey: this.key_additional
            })
            return false;
        }
        if ((!this.state.css_inactive_classname) || (this.state.css_inactive_classname.length === 0)) {
            this.setState({
                css_inactive_classname_rules: { isError: true, errorMessage: "Поле [неактивный css класс] не заполнено!" },
                tabKey: this.key_additional
            })
            return false;
        }*/
        if ((!this.state.tag) || (this.state.tag.length === 0)) {
            this.setState({
                tag_rules: { isError: true, errorMessage: "Поле [тэг] не заполнено!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((this.state.gameprovider_id <= 0) || (this.state.gameprovider_title.length === 0)) {
            this.setState({
                gameprovider_rules: { isError: true, errorMessage: "Поле [геймпровайдер] не выбрано!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((this.state.sort_order_category_key <= 0) || (this.state.sort_order_category_val.length === 0)) {
            this.setState({
                sort_order_category_rules: { isError: true, errorMessage: "Поле [порядок сортировки в категории] не выбран!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((this.state.sort_order_menu_key <= 0) || (this.state.sort_order_menu_val.length === 0)) {
            this.setState({
                sort_order_menu_rules: { isError: true, errorMessage: "Поле [порядок сортировки в меню] не выбран!" },
                tabKey: this.key_main
            });
            return false;
        }
        if ((this.state.cms_gameset_category_type_code <= 0) || (this.state.cms_gameset_category_type_title.length === 0)) {
            this.setState({
                cms_gameset_category_type_rules: { isError: true, errorMessage: "Поле [тип категории] не выбрано!" },
                tabKey: this.key_main
            });
            return false;
        }
        return true;
    };
    GameSetEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                description: this.state.description,
                title: this.state.title,
                tag: this.state.tag,
                gws_gameprovider_id: this.state.gameprovider_id,
                is_locked: this.state.is_locked,
                sort_order_category: this.state.sort_order_category_key,
                sort_order_menu: this.state.sort_order_menu_key,
                css_inactive_classname: this.state.css_inactive_classname,
                css_active_classname: this.state.css_active_classname,
                is_in_category: this.state.is_in_category,
                is_in_menu: this.state.is_in_menu,
                is_in_main_mobile_menu: this.state.is_in_main_mobile_menu,
                init_gm_cnt_in_category: this.state.init_gm_cnt_in_category,
                init_gm_cnt_in_menu: this.state.init_gm_cnt_in_menu,
                cms_gameset_category_type_code: this.state.cms_gameset_category_type_code,
                gameprovider_value: this.state.gameprovider_category_title
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Набор игр добавлен!");
            });
        }
    };
    GameSetEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    GameSetEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить набор игр";
        }
        else {
            return "Изменить набор игр";
        }
    };
    GameSetEditor.prototype.getActionButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    GameSetEditor.prototype.getMainEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Тэг:", placeholder: "Введите тэг" }, value: this.state.tag, onValueChanged: function (newVal) {
                    _this.setState({
                        tag: newVal,
                        tag_rules: { isError: false }
                    });
                }, required: true, rules: this.state.tag_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Геймпровайдер:", placeholder: "Выберите геймпровайдер" }, value: { key: this.state.gameprovider_id, value: this.state.gameprovider_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        gameprovider_id: newVal.key,
                        gameprovider_title: newVal.value,
                        gameprovider_rules: { isError: false }
                    }, function () {
                        _this.props.listGwsCategoryAvail.LoadData(_this.state.gameprovider_id);
                    });
                }, items: this.props.availGameproviders, disabled: this.props.record != null, required: true, rules: this.state.gameprovider_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Номер п/п в категории:", placeholder: "Выберите номер по порядку в категории" }, value: { key: this.state.sort_order_category_key, value: this.state.sort_order_category_val }, onValueChanged: function (newVal) {
                    _this.setState({
                        sort_order_category_key: newVal.key,
                        sort_order_category_val: newVal.value,
                        sort_order_category_rules: { isError: false }
                    });
                }, items: this.state.sort_order_category_avail, required: true, rules: this.state.sort_order_category_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Номер п/п в меню:", placeholder: "Выберите номер по порядку в меню" }, value: { key: this.state.sort_order_menu_key, value: this.state.sort_order_menu_val }, onValueChanged: function (newVal) {
                    _this.setState({
                        sort_order_menu_key: newVal.key,
                        sort_order_menu_val: newVal.value,
                        sort_order_menu_rules: { isError: false }
                    });
                }, items: this.state.sort_order_menu_avail, required: true, rules: this.state.sort_order_menu_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) { _this.setState({ description: newVal }); } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип категории:", placeholder: "Выберите тип категории" }, value: { key: this.state.cms_gameset_category_type_code, value: this.state.cms_gameset_category_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        cms_gameset_category_type_code: newVal.key,
                        cms_gameset_category_type_title: newVal.value,
                        cms_gameset_category_type_rules: { isError: false }
                    });
                }, items: this.props.dataCmsGameSetCategoryType, required: true, rules: this.state.cms_gameset_category_type_rules }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: { caption: "Провайдер:", placeholder: "Введите или выберите название провайдера", buttonHint: "Выбрать название провайдера" }, 
                // readonly={true}
                onButtonClick: this.doSelectGameProvider.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        gameprovider_category_title: newVal
                    });
                }, value: this.state.gameprovider_category_title, buttonIcon: "ellipsis" }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Набор заблокирован", value: this.state.is_locked, onChecked: function (checked) { _this.setState({ is_locked: checked }); } }),
            this.getActionButtons()));
    };
    GameSetEditor.prototype.doSelectGameProvider = function () {
        var _this = this;
        this.props.dlgSelectCss.SetTitle("Выбрать категорию геймпровайдера")
            .SetHideNotAutoCloseDialog(true)
            .SetOnCloseClick(function () { _this.props.dlgSelectCss.Close(); })
            .SetViewData(this.state.gameprovider_categories_avail)
            .SetOnSelectClick(function (key, value) {
            _this.setState({
                gameprovider_category_title: value,
            }, function () {
                _this.props.dlgSelectCss.Close();
            });
        }).Show();
    };
    GameSetEditor.prototype.doSelectInactiveCss = function () {
        var _this = this;
        this.props.dlgSelectCss.SetTitle("Выбрать CSS класс")
            .SetHideNotAutoCloseDialog(true)
            .SetOnCloseClick(function () { _this.props.dlgSelectCss.Close(); })
            .SetViewData(this.state.css_classes_avail)
            .SetOnSelectClick(function (key, value) {
            _this.setState({
                css_inactive_classname: value,
            }, function () {
                _this.props.dlgSelectCss.Close();
            });
        }).Show();
    };
    GameSetEditor.prototype.doSelectActiveCss = function () {
        var _this = this;
        this.props.dlgSelectCss.SetTitle("Выбрать CSS класс")
            .SetHideNotAutoCloseDialog(true)
            .SetOnCloseClick(function () { _this.props.dlgSelectCss.Close(); })
            .SetViewData(this.state.css_classes_avail)
            .SetOnSelectClick(function (key, value) {
            _this.setState({
                css_active_classname: value,
            }, function () {
                _this.props.dlgSelectCss.Close();
            });
        }).Show();
    };
    GameSetEditor.prototype.getAdditionalEditContent = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(CardRowButtonTextEditor_1.default, { texts: { caption: "Активный класс CSS:", placeholder: "Введите имя активного класса CSS", buttonHint: "Выбрать CSS класс" }, 
                //  readonly={true}
                onButtonClick: this.doSelectActiveCss.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        css_active_classname: newVal,
                    });
                }, value: this.state.css_active_classname, buttonIcon: "ellipsis" }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: { caption: "Неактивный класс CSS:", placeholder: "Введите имя неактивного класса CSS", buttonHint: "Выбрать CSS класс" }, 
                // readonly={true}
                onButtonClick: this.doSelectInactiveCss.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        css_inactive_classname: newVal,
                    });
                }, value: this.state.css_inactive_classname, buttonIcon: "ellipsis" }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Доступен в разделе 'категории'", value: this.state.is_in_category, onChecked: function (checked) { _this.setState({ is_in_category: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Доступен в разделе 'меню'", value: this.state.is_in_menu, onChecked: function (checked) { _this.setState({ is_in_menu: checked }); } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Доступен в разделе 'мобильное меню' на главной", value: this.state.is_in_main_mobile_menu, onChecked: function (checked) { _this.setState({ is_in_main_mobile_menu: checked }); }, disabled: !this.state.is_in_menu }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Кол-во игр категории:", placeholder: "Введите начальное кол-во игр категории" }, values: { max: 999999, min: 1, value: this.state.init_gm_cnt_in_category }, onValueChanged: function (newVal) {
                    _this.setState({
                        init_gm_cnt_in_category: newVal
                    });
                } }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Кол-во игр меню:", placeholder: "Введите начальное кол-во игр меню" }, values: { max: 999999, min: 1, value: this.state.init_gm_cnt_in_menu }, onValueChanged: function (newVal) {
                    _this.setState({
                        init_gm_cnt_in_menu: newVal
                    });
                } }),
            this.getActionButtons()));
    };
    GameSetEditor.prototype.onTabChange = function (key) {
        this.setState({ tabKey: key });
    };
    GameSetEditor.prototype.getContent = function () {
        if (this.state.tabKey === this.key_main) {
            return this.getMainEditContent();
        }
        if (this.state.tabKey === this.key_additional) {
            return this.getAdditionalEditContent();
        }
        return null;
    };
    GameSetEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(TabEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 670, activeTabKey: this.state.tabKey, tabs: [
                { key: this.key_main, tab: "Основные" },
                { key: this.key_additional, tab: "Дополнительно" }
            ], onTabChange: function (key) { _this.onTabChange(key); } }, this.getContent()));
    };
    return GameSetEditor;
}(React.Component));
exports.default = GameSetEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_gamesets_list/ui/component/GameSetsEditor.tsx
// module id = 1997
// module chunks = 0